/* Royal · Build your bed deal (2026-10-21, user: 20% off a whole bed built on Build your bed, 10% without the duvet,
   never anywhere else).
   Build your bed (sections/royal-build-bed.liquid) adds each piece with a hidden line property _bb = c (cover),
   s (sheets) or d (duvet). This script keeps one of two hidden discount codes on the cart, and only while the cart
   still holds what was built there:
     - every cover / sheet set / duvet in the cart came from Build your bed (no extra bedding bought on its own), and
     - exactly 1 duvet cover + 1 sheet set (2026-10-21, user: never 2 sheets, 2 covers or 2 duvets; one bed per
       order): with exactly 1 duvet -> FULL (20%); with no duvet -> PART (10%).
   Anything else (an extra sheet set added from a product page, a quantity changed, a piece removed) takes the code off.
   Other codes the shopper entered are left alone. The codes themselves live in Shopify admin (Discounts): percentage
   off the Duvet Covers, Sheets and Duvets collections, minimum 3 items (FULL) or 2 items (PART). Keep the names below
   in step with them, and the percentages with the section settings on the Build your bed page.
   Loaded by the Build your bed section, and on every page while the cart holds a built bed (snippets/royal-cart-offer). */
(function () {
  if (window.RoyalBedDeal) return;
  var FULL = 'BED20-7QK4X', PART = 'BED10-7QK4X', OURS = [FULL, PART];
  var TYPES = ['duvet covers', 'sheet sets', 'duvets'];

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function post(path, body) {
    return fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  /* which of our codes this cart has earned, or '' */
  function want(cart) {
    var n = { c: 0, s: 0, d: 0 }, extra = false;
    (cart.items || []).forEach(function (it) {
      var k = it.properties && it.properties._bb;
      if (k && n.hasOwnProperty(k)) n[k] += it.quantity;
      else if (TYPES.indexOf(String(it.product_type || '').toLowerCase()) > -1) extra = true;
    });
    if (extra || n.c !== 1 || n.s !== 1 || n.d > 1) return '';
    return n.d === 1 ? FULL : PART;
  }

  /* the cart sections on this page that show totals: the drawer and, on /cart, the cart page */
  function targets() {
    var list = [];
    ['cart-drawer-items', 'cart-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (!el || typeof el.getSectionsToRender !== 'function') return;
      try { el.getSectionsToRender().forEach(function (s) { if (document.getElementById(s.id)) list.push(s); }); } catch (e) {}
    });
    return list;
  }
  function paint(list, res) {
    if (!res || !res.sections) return;
    list.forEach(function (s) {
      var html = res.sections[s.section], host = document.getElementById(s.id);
      if (!html || !host) return;
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector(s.selector);
      var dst = host.querySelector(s.selector) || host;
      if (src) dst.innerHTML = src.innerHTML;
    });
  }

  var running = null, again = false;
  /* opts.render: return the drawer's sections so the caller can open the drawer with them (Build your bed's button);
     opts.force: post even when the codes are already right (so the caller always gets fresh sections) */
  function sync(opts) {
    opts = opts || {};
    if (running && !opts.render) { again = true; return running; }
    var p = fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cur = (cart.discount_codes || []).map(function (d) { return d.code; });
        var keep = cur.filter(function (c) { return OURS.indexOf(String(c).toUpperCase()) < 0; });
        var w = want(cart), next = w ? keep.concat(w) : keep;
        if (!opts.force && next.join(',').toUpperCase() === cur.join(',').toUpperCase()) return null;
        var list = opts.render ? [] : targets();
        var body = { discount: next.join(',') };
        var ids = opts.render ? ['cart-drawer', 'cart-icon-bubble'] : list.map(function (s) { return s.section; });
        if (ids.length) { body.sections = ids; body.sections_url = window.location.pathname; }
        return post('cart/update.js', body).then(function (res) { if (!opts.render) paint(list, res); return res; });
      });
    if (!opts.render) {
      running = p;
      p.catch(function () {}).then(function () { running = null; if (again) { again = false; sync(); } });
    }
    return p;
  }

  window.RoyalBedDeal = { FULL: FULL, PART: PART, want: want, sync: sync };

  /* any cart change on the page (drawer quantities, product pages, quick view) is checked a moment later, after the
     theme has redrawn the drawer, so the corrected totals are the ones left on screen */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (e && e.source === 'royal-bed') return;
      setTimeout(sync, 400);
    });
  }
  sync();
})();
